import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { CAPService } from "../../core/services/cap-service";
import { Router, ActivatedRoute } from "@angular/router";
import * as $ from "jquery";
import { PagerService } from "../../core/services/pager.service";
import { DatePipe } from "@angular/common";
import { IDropdownSettings } from "ng-multiselect-dropdown";

@Component({
  selector: "app-activate-authcode",
  templateUrl: "./activate-authcode.component.html",
  styleUrls: ["./activate-authcode.component.css"],
})
export class ActivateAuthcodeComponent implements OnInit {
  txtAuthcode = "";
  txtempid = "";
  txtwbse = "";
  txtEnterpriseID = "";
  txtsuperEnterpriseID = "";
  txtrequestid = "";
  AuthDetails;
  Description: any;
  Insertdata: any;
  updateauth: any;
  public dlstStatus='';
  public StatusList;
  

  i = 0;
  Count = 0;
  maincount = 0;
  mainCountSingle = 0;
  CountAll = 1;
  successfulData;
  FacilityList = [];
  FacValues: any[];
  grdFacModel: any[];
  selectedAll;
  public SelectedEnterpriseIDList;
  public SelectedEnterpriseIDInList;
  public SelectedEnterpriseIDList1;
  public SelectedEnterpriseIDInList1;
  public LocationList;
  public selectedLocation = [];
  public showRecEIdlistbox;
  public showRecEIdlistbox1;
  dataLoader: boolean;
  gridData: any;
  //public country="N";

  // pager object
  pager: any = {};
  // array of all items to be paged
  private allItems: any[];
  // paged items
  pagedItems: any[];
  RequestTypeList;
    public RequestType;
  constructor(
    private router: Router,
    private capservice: CAPService,
    private pagerService: PagerService,
    private changeDetectorRef: ChangeDetectorRef,
    private datePipe: DatePipe
  ) {}
  public dropDownSettings: IDropdownSettings;
  _Country = this.capservice.country;
  LoginEnterpriseID = this.capservice.enterpriseid;
  EmployeeNO = this.capservice.EmployeeNO;
  Country = this.capservice.country;
  Role = this.capservice.ReportRole;
  RoleReport = this.capservice.Role;
  country = this.RoleReport == "Regional Voice Admin" ? this.Country : "N";

  ngOnInit() {

    this.dataLoader = true;
    // this.capservice.GetAuthcodeRequests('Activate', $('#txtAuthcode').val(), this.country).subscribe(data=>{
    //   if (data.length >= 0) {
    //     this.successfulData = { ActivateAuthcodes: data, selected: {} }
    //      this.allItems=data;
    //      this.setPage(1);
    // }
    // });
    this.StatusList = [{name:"Activated"},{ name: "Not Activated"}]
    this.dropDownSettings = {
      itemsShowLimit: 1,
      idField: "label_id",
      textField: "label",
      selectAllText: "Check All",
      unSelectAllText: "UnCheck All",
      maxHeight: 100,
    };
    this.successfulData = {
      ActivateAuthcodes: "",
      RITMNumber: "",
      eId: "",
      FromDate: "",
      ToDate: "",
      Facility: "",
      wbsElement: "",
      authCodeId: "",
      Description: "",
      selected: "",
    };
    this.AuthDetails = {
      RITMNumber: "",
      eId: "",
      FromDate: "",
      ToDate: "",
      Facility: "",
      wbsElement: "",
      authCodeId: "",
    };

    var MultiLocationListObj = { MultiLocationListArray: [] };
    this.capservice
      .GetVoiceAdminDetails(null, "AuthcodeLocation", null)
      .subscribe((data) => {
        this.LocationList = data;
        //this.dataLoader = true;
        for (var i = 0; i < data.length; i++) {
          var location = { label_id: i, label: data[i].Facility };

          MultiLocationListObj.MultiLocationListArray.push(location);
        }
        this.LocationList = MultiLocationListObj.MultiLocationListArray;
        //this.dataLoader = false;
      });
    this.GetDropdownList();
    this.CountryList();
    this.ActivateAuthcodeDetails();
    //this.getfacilitylist();
    this.RequestTypeList = [
      
      { name: 'Normal Deactivation Requests', },
      { name: 'Exit Deactivation Requests', }
    ]
  }
  GetEnterpriseID() {
    if (this.txtEnterpriseID.length >= 3) {
      this.capservice
        .AutoPopulateGetEnterpriseIDList(this.txtEnterpriseID)
        .subscribe(
          (data) => {
            this.SelectedEnterpriseIDList = data;
          },
          (err) => {}
        );
      this.showRecEIdlistbox = true;
    } else {
      this.showRecEIdlistbox = false;
    }
  }

  PostEnterpriseID() {
    this.showRecEIdlistbox = false;
    if (this.SelectedEnterpriseIDInList != "") {
      this.txtEnterpriseID = this.SelectedEnterpriseIDInList[0];
      this.showRecEIdlistbox = false;
    }
  }
  GetEnterpriseID1() {
    if (this.txtsuperEnterpriseID.length >= 3) {
      this.capservice
        .AutoPopulateGetEnterpriseIDList(this.txtsuperEnterpriseID)
        .subscribe(
          (data) => {
            this.SelectedEnterpriseIDList1 = data;
          },
          (err) => {}
        );
      this.showRecEIdlistbox1 = true;
    } else {
      this.showRecEIdlistbox1 = false;
    }
  }

  PostEnterpriseID1() {
    this.showRecEIdlistbox1 = false;
    if (this.SelectedEnterpriseIDInList1 != "") {
      this.txtsuperEnterpriseID = this.SelectedEnterpriseIDInList1[0];
      this.showRecEIdlistbox1 = false;
    }
  }
  ShowData() {
    var Location = "";
    var Status='';
    if (
      $("#txtAuthcode").val() == "" &&
      this.txtempid == "" &&
      this.txtwbse == "" &&
      this.txtEnterpriseID == "" &&
      this.txtsuperEnterpriseID == "" &&
      this.selectedLocation.length == 0 &&
      this.txtrequestid == "" &&
      (this.dlstStatus == ""|| this.dlstStatus == "Select")
    ) {
      alert("Please select value to search");
    } else {
      // this.capservice.GetAuthcodeRequests('SearchActivate', $('#txtAuthcode').val(), this.country).subscribe(data=>{
      //   if (data.length > 0) {
      //     this.successfulData = { ActivateAuthcodes : data, selected: { } }
      //     this.allItems=data;
      //     this.setPage(1);
      for (var i = 0; i < this.selectedLocation.length; i++) {
        Location = Location + "," + this.selectedLocation[i].label;
      }
      if(this.dlstStatus=="Activated")
      {
      Status="Activation";
      }
      if(this.dlstStatus=="Not Activated")
      {
       Status="Not Activation"
      }
      this.capservice
        .AuthCodeSearchRequest(
          "SearchActivate",
          $("#txtAuthcode").val(),
          this.txtempid,
          this.txtwbse,
          this.txtEnterpriseID,
          this.txtsuperEnterpriseID,
          Location,
          this.txtrequestid,
          Status
        )
        .subscribe((data) => {
          if (data.length > 0) {
            this.successfulData = { ActivateAuthcodes: data, selected: {} };
            this.allItems = data;
            this.setPage(1);
          } else {
            $("#txtAuthcode").val("");
            this.txtempid = "";
            this.txtwbse = "";
            this.txtEnterpriseID = "";
            this.txtsuperEnterpriseID = "";
            this.txtrequestid = "";
            this.dlstStatus = "";
            this.selectedLocation = [];
            this.showRecEIdlistbox1 = false;
            this.showRecEIdlistbox = false;
            alert("No Records Found");
            this.ActivateAuthcodeDetails();
          }
        });
    }
  }

  getfacilitylist() {
    this.capservice.FacilityList("Philippines").subscribe((data) => {
      this.FacilityList = data;
      //this.dataLoader = false;
    });
  }

  AuthCodeAdd() {
    var message = "";

    this.AuthDetails.FromDate = $(".startDate").val();

    this.AuthDetails.ToDate = $(".ToDate").val();
    if ($("#grdRITMNumber").val() == "") {
      message = "Please Enter RITM Number";
    }
    if ($("#grdfUserId").val() == "") {
      message = message + "\n" + "Please Enter EnterpriseID";
    }
    if ($(".startDate").val() == "") {
      message = message + "\n" + "Please Select Start Date";
    }
    if ($(".ToDate").val() == "") {
      message = message + "\n" + "Please Select To Date";
    }
    if (
      this.successfulData.selected.Facility == "" ||
      this.successfulData.selected.Facility == null ||
      this.successfulData.selected.Facility == undefined
    ) {
      message = message + "\n" + "Please Select Facility";
    }
    if ($("#grdfwbsElement").val() == "") {
      message = message + "\n" + "Please enter WBS Element";
    }
    if ($("#grdfauthCodeId").val() == "") {
      message = message + "\n" + "Please enter Auth Code Id";
    }

    if (message != "") {
      alert(message);
    } else {
      this.AuthDetails.EnterpriseID = this.LoginEnterpriseID;
      this.AuthDetails.sapId = this.EmployeeNO;
      var FacilityNames = "";

      for (var i = 0; i < this.Description.length; i++) {
        FacilityNames = FacilityNames + "," + this.Description[i].label;
      }

      this.AuthDetails.Facility = FacilityNames.slice(1, FacilityNames.length);
      this.capservice
        .InsertAuthCodeDetails(this.AuthDetails)
        .subscribe((data) => {
          this.Insertdata = data["Records"];
          alert(data);

          if (
            this.Insertdata != "Already Exists" &&
            this.Insertdata != "Please enter a valid  EnterpriseID" &&
            this.Insertdata != "Please Enter valid WBS"
          ) {
            this.clear();
            this.reload();
            this.reset();
          }
        });
    }
  }

  GetDropdownList() {
    var MultiDestiantionObj = { MultiDestinationArray: [] };
    this.FacValues = [];

    this.capservice.FacilityList("Philippines").subscribe((data) => {
      this.grdFacModel = data;
      for (var i = 0; i < data.length; i++) {
        var fac = { label: this.FacilityList[i].Description };

        MultiDestiantionObj.MultiDestinationArray.push(fac);
      }
      this.grdFacModel = MultiDestiantionObj.MultiDestinationArray;
    });
  }

  AuthCodeUpdate(idx) {
    var message = "";
    if ($("#_RITMNumber").val() == "") {
      message = "Please Enter RITM Number";
    }
    if ($("#_UserId").val() == "") {
      message = message + "\n" + "Please Enter EnterpriseID";
    }
    if ($("._startDate").val() == "") {
      message = message + "\n" + "Please Select Start Date";
    }
    if ($("._ToDate").val() == "") {
      message = message + "\n" + "Please Select To Date";
    }
    if (
      this.successfulData.selected.Facility == "" ||
      this.successfulData.selected.Facility == undefined
    ) {
      message = message + "\n" + "Please Select Facility";
    }
    if ($("#_wbsElement").val() == "") {
      message = message + "\n" + "Please enter WBS Element";
    }
    if ($("#_authCodeId").val() == "") {
      message = message + "\n" + "Please enter Auth Code Id";
    }
    if (message != "") {
      alert(message);
    } else {
      this.successfulData.ActivateAuthcodes[idx] = Object.assign(
        {},
        this.successfulData.selected
      );
      this.successfulData.selected.EnterpriseID = this.LoginEnterpriseID;
      // $scope.successfulData.selected.token = MYCASService.tokenManager();
      this.successfulData.selected.sapId = this.EmployeeNO;
      // var FacilityNames = '';
      // for (var i = 0; i < this.Description.length; i++) {
      //   FacilityNames = FacilityNames + ',' + this.Description[i].label
      // }
      // this.successfulData.selected.Facility = FacilityNames.slice(1, FacilityNames.length);
      this.capservice
        .UpdateAuthCodeDetails(this.successfulData.selected)
        .subscribe((data: any) => {
          alert(data);
          if (
            data != "Already Exists" &&
            data != "Please enter a valid  EnterpriseID" &&
            data != "Please Enter valid WBS"
          ) {
            this.clear();
            this.reload();
            this.reset();
          }
        });
    }
  }

  // AuthCodeUpdate(idx) {
  //   var message = '';

  //   if ($('#_authCodeId').val() == '') {
  //       message = "Please enter AuthCode ?";
  //   }

  //   if (message != '') {
  //       alert(message);
  //   }
  //   else {
  //     this.successfulData.ActivateAuthcodes[idx] = Object.assign({}, this.successfulData.selected);
  //           this.successfulData.selected.EnterpriseID = this.LoginEnterpriseID;
  //           //this.successfulData.selected.token = MYCASService.tokenManager();
  //           this.successfulData.selected.sapId = this.EmployeeNO;

  //           this.capservice.UpdateAuthCodeDetails(this.successfulData.selected).subscribe(data=>{
  //             console.log(data);
  //             this.updateauth=data["Records"];
  //             alert(this.updateauth);
  //             if (this.updateauth != "Already Exists" && this.updateauth != "Please enter a valid  EnterpriseID" && this.updateauth != "Please Enter valid WBS") {
  //               this.clear();
  //               this.reload();
  //               this.reset();
  //           }
  //           });
  //   }
  // }

  CountryList() {
    this.capservice.FacilityList("Philippines").subscribe((data) => {
      var MultiFacilityObj = { MultiFacilityArray: [] };
      this.FacilityList = data;
      for (var i = 0; i < this.FacilityList.length; i++) {
        var fac = { label: this.FacilityList[i].Description };

        MultiFacilityObj.MultiFacilityArray.push(fac);
      }
      this.FacilityList = MultiFacilityObj.MultiFacilityArray;
    });
  }

  ActivateAuthcodeDetails() {
    this.capservice
      .GetAuthcodeRequests("Activate", this.EmployeeNO, this.country)
      .subscribe((data) => {
        this.dataLoader = true;
        if (data.length > 0) {
          this.successfulData = { ActivateAuthcodes: data, selected: {} };
          this.allItems = data;
          this.setPage(1);
          this.dataLoader = false;
        }
        this.dataLoader = false;
      });
  }
  /*
  checkAll(type, checked) {
    if (type == 'ActiveAuthCOde') {
      if (checked) {
        this.selectedAll = true;
        this.successfulData.ActivateAuthcodes.forEach(ActivateAuthcode => {
          ActivateAuthcode.checked = checked;
        });

      } else {
        this.selectedAll = false;
        this.successfulData.ActivateAuthcodes.forEach(ActivateAuthcode => {
          ActivateAuthcode.checked = checked;
        });
      }      
    }    
  }
  */

  DeleteAuthCode(ActivateAuthcode) {
    ActivateAuthcode.sapId = this.EmployeeNO;
    //console.log(ActivateAuthcode);
    this.capservice.DeleteAuthCode(ActivateAuthcode).subscribe((data) => {
      alert(data);
      this.clear();
      this.reload();
      this.reset();
    });
  }

  reset() {
    this.successfulData.selected = {};
  }

  clear() {
    $("#grdRITMNumber").val("");
    $("#grdfUserId").val("");
    $(".startDate").val("");
    $(".ToDate").val("");
    $("#grdfFacility").val("");
    $("#grdfwbsElement").val("");
    $("#grdfauthCodeId").val("");

    $("#_RITMNumber").val("");
    $("#_UserId").val("");
    $("._startDate").val("");
    $("._ToDate").val("");
    $("#_Facility").val("");
    $("#_wbsElement").val("");
    $("#_authCodeId").val("");
    this.Description = [];
  }

  EditAuthCode(ActivateAuthcode) {
    this.successfulData.selected = Object.assign({}, ActivateAuthcode);
    //console.log(this.successfulData.selected);
  }

  reload() {
    $("#txtAuthcode").val("");
    this.txtempid = "";
    this.txtwbse = "";
    this.txtEnterpriseID = "";
    this.txtsuperEnterpriseID = "";
    this.txtrequestid = "";
    this.selectedLocation = [];
    this.showRecEIdlistbox1 = false;
    this.showRecEIdlistbox = false;
    this.dlstStatus = "";
    this.selectedAll = false;


    //Change it to employeeno
    // this.capservice.GetAuthcodeRequests('Activate', $('#txtAuthcode').val(), this.country).subscribe(data=>{
    //  if (data.length >= 0) {
    //     this.successfulData = { ActivateAuthcodes: data, selected: {} }
    //     this.allItems=data;
    //     this.setPage(1);
    // }
    // });
    this.ActivateAuthcodeDetails();
  }

  SubmitData() {
    this.successfulData.ActivateAuthcodes.forEach((ActivateAuthcode) => {
      if ($("input:checkbox:checked").length > 1) {
        this.maincount = this.successfulData.ActivateAuthcodes.length;
      } else {
        this.mainCountSingle = $("input:checkbox:checked").length;
      }
      if (ActivateAuthcode.checked) {
        this.i++;
        //this.capservice.AuthCodeDetails(ActivateAuthcode.RITMNumber, ActivateAuthcode.eId, "Activate", ActivateAuthcode.Facility, ActivateAuthcode.authCodeId, ActivateAuthcode.managerEid).subscribe(data=>{
        this.capservice
          .AuthCodeDetails(
            ActivateAuthcode.RITMNumber,
            ActivateAuthcode.eId,
            "Activate",
            ActivateAuthcode.Facility,
            ActivateAuthcode.authCodeId,
            ActivateAuthcode.managerEid,
            this.LoginEnterpriseID
          )
          .subscribe((data) => {
            if (data) {
              this.Count++;
              this.CountAll++;
              this.popup("True");
            }
          });
      }
      this.reload();
      this.ActivateAuthcodeDetails();
    });
  }
  // ExportData1(){
  //   var RequestNo = '';
  //   var ReportName = 'Activate_Authcode.xlsx';

  //       this.capservice.AuthCodeDetailsBulkDownload('Activate', null, this.country).subscribe((data:Blob) => {
  //         if (window.navigator && window.navigator.msSaveOrOpenBlob){ // for IE
  //           window.navigator.msSaveOrOpenBlob(data, ReportName);
  //           //this.loaderGif=false;
  //       }
  //         else{
  //           var link = document.createElement('a');
  //           link.href = window.URL.createObjectURL(data);
  //           link.download = ReportName;
  //           link.click();
  //           //this.loaderGif=false;
  //       }
  //       },function (x) {
  //           console.log(x);
  //           alert('Acknowledgement failed');
  //           this.loaderGif=false;
  //       })

  // }

  ExportData() {
    debugger;

    var RequestNo = "";
    var ReportName = "Activate_Authcode.xlsx";
    var Location = "";
    // this.successfulData.ActivateAuthcodes.forEach(ActivateAuthcode => {
    //    if (ActivateAuthcode.checked) {
    //     for (var i = 0; i < ActivateAuthcode.checked; i++)
    //     {
    //       RequestNo = RequestNo + ',' + ActivateAuthcode.RITMNumber
    //      }
    //   }
    // });
    for (var i = 0; i < this.selectedLocation.length; i++) {
      Location = Location + "," + this.selectedLocation[i].label;
    }
    //     this.successfulData.ActivateAuthcodes.forEach(ActivateAuthcode => {
    //     for (var i = 0; i < this.successfulData.length; i++) {
    //       RequestNo = RequestNo + ',' + ActivateAuthcode.RITMNumber
    //     }
    // });

    this.capservice
      .AuthCodeSearchRequestBulkDownload(
        "SearchActivate",
        $("#txtAuthcode").val(),
        this.txtempid,
        this.txtwbse,
        this.txtEnterpriseID,
        this.txtsuperEnterpriseID,
        Location,
        this.txtrequestid,
        this.dlstStatus
      )
      .subscribe(
        (data: Blob) => {
          //this.capservice.AuthCodeDetailsBulkDownload('Activate', RequestNo, this.country).subscribe((data:Blob) => {
          if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
            // for IE
            (window.navigator as any).msSaveOrOpenBlob(data, ReportName);
            //this.loaderGif=false;
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(data);
            link.download = ReportName;
            link.click();
            //this.loaderGif=false;
          }
        },
        function (x) {
          console.log(x);
          alert("Acknowledgement failed");
          this.loaderGif = false;
        }
      );
    RequestNo = "";
  }

  ExportCiscoData() {
    var ReportName = "ActiveAuthcode_Cisco.xlsx";
    this.capservice
      .AuthCodeDetailsBulkDownload("ActiveCiscoAuthcode", null, this.country)
      .subscribe(
        (data: Blob) => {
          if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
            // for IE
            (window.navigator as any).msSaveOrOpenBlob(data, ReportName);
            //this.loaderGif=false;
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(data);
            link.download = ReportName;
            link.click();
            //this.loaderGif=false;
          }
        },
        function (x) {
          console.log(x);
          alert("Acknowledgement failed");
          this.loaderGif = false;
        }
      );
  }
  //checkall chk
  checkAll(isChecked) {
    this.selectedAll = isChecked;
    this.successfulData.ActivateAuthcodes.forEach((ActivateAuthcode) => {
      ActivateAuthcode.checked = this.selectedAll;
    });
  }

  popup(Status) {
    if (this.Count == this.mainCountSingle) {
      if (Status == "True") {
        this.ActivateAuthcodeDetails();
        alert("Updated successfully");
      }
    } else if (this.CountAll == this.maincount) {
      if (Status == "True") {
        this.ActivateAuthcodeDetails();
        alert("Updated successfully");
      }
    } else {
      this.ActivateAuthcodeDetails();
      alert("Updated successfully");
    }
  }

  setPage(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    // get pager object from service
    this.pager = this.pagerService.getPager(this.allItems.length, page, 5);

    // get current page of items
    this.gridData = this.allItems.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
    this.changeDetectorRef.detectChanges();
  }
}
